module.exports = {
  loginComponent: {
    login: "登錄",
    logout : "退出登錄"
  },
};



// WEBPACK FOOTER //
// ./src/language/zh_TW.js